import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getWeddingFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `Are food ${vehicleType}s a good option for wedding catering?`,
    answer: `Yes — food ${vehicleType}s are an increasingly popular choice for wedding catering because they're flexible, fun, and memorable. They allow couples to offer fresh, made-to-order food in a relaxed, guest-friendly format. Food ${vehicleType}s work especially well for outdoor weddings, non-traditional venues, cocktail-style receptions, and late-night snacks, and they're often more adaptable than traditional caterers.`
  },
  {
    question: `How much does food ${vehicleType} wedding catering cost in ${cityName}?`,
    answer: `Food ${vehicleType} wedding catering costs in ${cityName} vary based on guest count, menu selection, service time, and whether ${vehicleType}s are serving the main meal, late-night snacks, or dessert. Smaller weddings may start around a few thousand dollars, while larger receptions with multiple ${vehicleType}s can scale higher. ${siteTitle} lets you compare real quotes from wedding-experienced food ${vehicleType}s so you can find options that fit your vision and budget with clear, upfront pricing.`
  },
  {
    question: `How many food ${vehicleType}s do I need for my wedding?`,
    answer: `The number of food ${vehicleType}s needed depends on your guest count, service style, and timeline. As a general rule, one food ${vehicleType} can comfortably serve 75–150 guests within a reasonable window. For larger weddings or faster service, couples often book multiple ${vehicleType}s or pair a main entrée ${vehicleType} with a dessert or late-night snack ${vehicleType}. Our team can help you determine the right setup for your wedding.`
  },
  {
    question: `Can food ${vehicleType}s accommodate dietary restrictions at weddings?`,
    answer: `Absolutely. Many food ${vehicleType}s offer vegetarian, vegan, gluten-free, and allergy-friendly options. Some couples choose a mix of ${vehicleType}s or customized menus to ensure all guests are accommodated. When you submit your wedding catering request, you can note dietary needs and preferences so we can match you with food ${vehicleType}s that fit your guest list.`
  },
  {
    question: `When should I book a food ${vehicleType} for my wedding?`,
    answer: `For the best availability, we recommend booking your wedding food ${vehicleType} 3–6 months in advance, especially for summer weekends and popular ${cityName} wedding venues. Booking early gives you more menu options and flexibility, though some ${vehicleType}s may still be available for shorter timelines depending on the date.`
  },
  {
    question: `Can food ${vehicleType}s serve at my wedding venue in ${cityName}?`,
    answer: `Most food ${vehicleType}s can serve at a wide range of wedding venues, including farms, vineyards, private homes, parks, rooftops, and industrial spaces. Some venues may have specific requirements around access, power, or parking, and our team can help coordinate those details with your venue and chosen food ${vehicleType} to ensure a smooth setup.`
  }
];

function WeddingFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getWeddingFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default WeddingFaq;
